import Layout from '@/views/layout'
export default {
  path: '/obddevice',
  menuName: 'OBD 设备',
  component: Layout,
  name: 'ObdDevice',
  meta: { title: 'obddevices', icon: 'OBD-device', iconType: 'svg' },
  children: [
    {
      path: 'manage',
      name: 'terminal',
      // name: 'Manage',
      menuName: 'OBD设备管理',
      component: () => import('@/views/obdDevice/manage'),
      meta: { title: 'OBD Device Management', icon: 'manage', iconType: 'svg' }
    },
    {
      path: 'nineFiveResponse',
      name: 'configResponse',
      menuName: 'OBD配置响应管理',
      component: () => import('@/views/obdDevice/nineFiveResponse'),
      meta: { title: 'OBD Configuration Response Management', icon: 'manage', iconType: 'svg' }
    },
    {
      path: 'obdConfig',
      name: 'terminalConfig',
      menuName: '终端设定配置管理',
      component: () => import('@/views/obdDevice/obdConfig'),
      meta: { title: 'Terminal settings configuration management', icon: 'manage', iconType: 'svg' }
    }

  ]
}